export function toUpperCase(str: string) {
  return str.toUpperCase().split(" ").join("_");
}

export const stringToYellingCase = (str: string) => {
  return str
    .split(" ")
    .map(word => word.toUpperCase())
    .join("_");
};
export const slugify = (str: string) =>
  str
    .toLowerCase()
    .trim()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");

export const formattedInventoryId = (itemId: string) => itemId.slice(0, 8).toUpperCase();

export const joinWithAnd = (arr: string[]) => {
  if (arr.length === 0) return "";
  if (arr.length === 1) return arr[0];
  if (arr.length === 2) return arr.join(" and ");
  return arr.slice(0, -1).join(", ") + " and " + arr[arr.length - 1];
};
